import React from 'react';
import { IonText, IonIcon } from '@ionic/react';
import { checkmarkCircle, closeCircle } from 'ionicons/icons';

interface PasswordMatchIndicatorProps {
    password: string;
    confirmPassword: string;
}

export const PasswordMatchIndicator: React.FC<PasswordMatchIndicatorProps> = ({ 
    password, 
    confirmPassword 
}) => {
    // Only show indicator if both fields have values
    if (!password || !confirmPassword) {
        return null;
    }

    const doPasswordsMatch = password === confirmPassword;

    return (
        <div className="ion-padding-vertical" style={{ display: 'flex', alignItems: 'center' }}>
            <IonIcon
                icon={doPasswordsMatch ? checkmarkCircle : closeCircle}
                color={doPasswordsMatch ? 'success' : 'danger'}
                style={{ marginRight: '8px' }}
            />
            <IonText color={doPasswordsMatch ? 'success' : 'danger'}>
                {doPasswordsMatch ? 'Passwords match' : 'Passwords do not match'}
            </IonText>
        </div>
    );
}; 